import React from 'react';

class ErrorBoundary extends React.Component<{}, { hasError: boolean }> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
  }

  render() {
    if (this.state.hasError) {
      return <></>;
    }

    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/ErrorBoundary.tsx